import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

export default [
  {
    header: 'navigation.finance',
  },
  {
    title: 'navigation.admin-transactions',
    route: 'super:invoices',
    adminPermissions: [ADMIN_PERMISSIONS.PAYMENT],
    icon: 'DollarSignIcon',
  },
  {
    title: 'navigation.external-payment',
    route: 'super:external-payment',
    adminPermissions: [ADMIN_PERMISSIONS.PAYMENT],
    icon: 'CreditCardIcon',
  },
  {
    title: 'navigation.quotations',
    route: 'super:quotations',
    adminPermissions: [ADMIN_PERMISSIONS.PAYMENT],
    icon: 'ClipboardIcon',
  },
  {
    title: 'accounts.gifts_grace',
    route: 'super:gifts-grace',
    adminPermissions: [ADMIN_PERMISSIONS.CHANGE_PACKAGE],
    icon: 'ClipboardIcon',
  },
]
